export default {
  fi: {
    FaultIndexScene: {
      title: 'Vikailmoitukset',
      add: 'Luo uusi',
    },
  },
};
